import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { requestNotificationPermission } from "../firebase"; // Import your function

const OwnerLoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [accountType, setAccountType] = useState("boulangerie");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    if (!email || !password || !accountType) {
      setError("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(`${API_URL}/api/owner/login`, {
        email,
        password,
        accountType,
      });

      console.log("Login response:", response);

      localStorage.setItem("ownerToken", response.data.token);
      alert("Connexion réussie !");

      if (accountType === "boulangerie") {
        window.location.href = "/addItems";
      } else if (accountType === "restaurant") {
        window.location.href = "/addRestMenu";
      }
    } catch (err) {
      setError(err.response?.data?.message || "La connexion a échoué. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const handleOwnerSignUp = () => {
    navigate("/ownersignupform"); // Redirects to the /addCategoryAndItems route
  };
  return (
    <>
      <div id="main-container" className="mainContainer">
        {/* Header */}
        <header id="header" className="header">
          <div className="headerContainer">
            <div className="headerTitle">Lememeprix</div>
          </div>
        </header>

        {/* Login Section */}
        <main className="main">
          <div id="login-container" className="loginContainer">
            {/* Left Hero Section */}
            {isLargeScreen && (
              <div id="login-hero" className="loginHero">
                <img
                  className="loginHeroImage"
                  src="https://storage.googleapis.com/uxpilot-auth.appspot.com/7183815703-8d5ddd939bfaff58d6b9.png"
                  alt="modern french bakery interior with warm lighting and fresh pastries displayed on wooden shelves, cinematic style, moody atmosphere"
                />
                <div className="loginHeroOverlay">
                  <div className="loginHeroContent">
                    <h1 className="loginHeroTitle">Bienvenue</h1>
                    <p className="loginHeroText">Connectez-vous pour explorer les meilleures spécialités françaises</p>
                  </div>
                </div>
              </div>
            )}

            {/* Right Login Form */}
            <div id="login-form-container" className="loginFormContainer">
              <div className="loginFormWrapper">
                <div className="loginHeader">
                  <h2 className="loginTitle">Se Connecter</h2>
                  <p className="loginSubtitle">Accédez à votre compte pour commencer à commander</p>
                </div>

                <form id="login-form" className="loginForm" onSubmit={handleSubmit}>
                  {error && <div className="errorMessage">{error}</div>}
                  <div className="formField">
                    <label className="formLabel">Adresse Email</label>
                    <div className="inputWrapper">
                      <i className="fa-regular fa-envelope inputIcon"></i>
                      <input
                        type="email"
                        autoComplete="email"
                        className="formInput"
                        placeholder="Entrez votre email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="formField">
                    <label className="formLabel">Mot de passe</label>
                    <div className="inputWrapper">
                      <i className="fa-solid fa-lock inputIcon"></i>
                      <input
                        type="password"
                        className="formInput"
                        placeholder="Entrez votre mot de passe"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      <button type="button" className="eyeButton">
                        <i className="fa-regular fa-eye"></i>
                      </button>
                    </div>
                  </div>

                  {/* Account Type Selection */}
                  <div className="formField">
                    <label className="formLabel">Type de compte</label>
                    <div className="inputWrapper">
                      <select
                        className="formInput"
                        value={accountType}
                        onChange={(e) => setAccountType(e.target.value)}
                      >
                        <option value="boulangerie">Boulangerie</option>
                        <option value="restaurant">Restaurant</option>
                      </select>
                    </div>
                  </div>

                  <div className="loginOptions">
                    <label className="rememberMeLabel">
                      <input type="checkbox" className="rememberMeCheckbox" />
                      <span className="rememberMeText">Se souvenir de moi</span>
                    </label>
                    <span className="forgotPassword">Mot de passe oublié ?</span>
                  </div>

                  <button type="submit" className="submitButton" disabled={loading}>
                    {loading ? "Connexion..." : "Se connecter"}
                  </button>

                  <div className="socialLogin">
                    <div className="socialLoginDivider"></div>
                    <div className="socialLoginText">
                      <span>Ou continuer avec</span>
                    </div>
                  </div>

                  <div className="socialButtons">
                    <button type="button" className="socialButton">
                      <i className="fa-brands fa-google socialIcon"></i>
                      Google
                    </button>
                    <button type="button" className="socialButton">
                      <i className="fa-brands fa-facebook socialIcon"></i>
                      Facebook
                    </button>
                  </div>

                  <p className="signupText">
                    Vous n'avez pas de compte ?
                    <span  onClick={handleOwnerSignUp} className="signupLink">S'inscrire</span>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </main>
      </div>

      <style jsx>{`
        .mainContainer {
          min-height: 100vh;
          background-color: white;
        }

        .header {
          position: fixed;
          width: 100%;
          background-color: white;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          z-index: 50;
        }

        .headerContainer {
          maxWidth: 1200px;
          margin: 0 auto;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .headerTitle {
          fontSize: 1.5rem;
          font-weight: bold;
        }

        .main {
          paddingTop: 5rem;
        }

        .loginContainer {
          min-height: calc(100vh - 5rem);
          display: flex;
        }

        .loginHero {
          display: none;
          width: 50%;
          position: relative;
        }

        @media (min-width: 1024px) {
          .loginHero {
            display: block;
          }
        }

        .loginHeroImage {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .loginHeroOverlay {
          position: absolute;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.4);
        }

        .loginHeroContent {
          padding: 3rem;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .loginHeroTitle {
          fontSize: 3rem;
          font-weight: bold;
          color: white;
          margin-bottom: 1.5rem;
        }

        .loginHeroText {
          fontSize: 1.25rem;
          color: rgba(255, 255, 255, 0.9);
        }

        .loginFormContainer {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
        }

        @media (min-width: 1024px) {
          .loginFormContainer {
            width: 50%;
          }
        }

        .loginFormWrapper {
          width: 100%;
          max-width: 32rem;
        }

        .loginHeader {
          text-align: center;
          margin-bottom: 3rem;
        }

        .loginTitle {
          fontSize: 2.25rem;
          font-weight: bold;
          margin-bottom: 1rem;
        }

        .loginSubtitle {
          color: #6b7280;
        }

        .loginForm {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .formField {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .formLabel {
          display: block;
          fontSize: 0.875rem;
          font-weight: 500;
          color: #374151;
        }

        .inputWrapper {
          position: relative;
        }

        .inputIcon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
        }

        .formInput {
          width: 100%;
          padding: 0.75rem 1rem;
          padding-left: 3rem;
          border: 1px solid #d1d5db;
          borderRadius: 0.5rem;
          outline: none;
        }

        .formInput:focus {
          border-color: #ef4444;
          box-shadow: 0 0 0 1px #ef4444;
        }

        .eyeButton {
          position: absolute;
          right: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
          background: none;
          border: none;
          cursor: pointer;
        }

        .loginOptions {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .rememberMeLabel {
          display: flex;
          align-items: center;
        }

        .rememberMeCheckbox {
          width: 1rem;
          height: 1rem;
          border: 1px solid #d1d5db;
          borderRadius: 0.25rem;
          color: #ef4444;
        }

        .rememberMeCheckbox:focus {
          box-shadow: 0 0 0 2px #ef4444;
        }

        .rememberMeText {
          margin-left: 0.5rem;
          fontSize: 0.875rem;
          color: #6b7280;
        }

        .forgotPassword {
          fontSize: 0.875rem;
          color: #ef4444;
          cursor: pointer;
        }

        .forgotPassword:hover {
          color: #dc2626;
        }

        .submitButton {
          width: 100%;
          background-color: #ef4444;
          color: white;
          padding: 0.75rem;
          borderRadius: 0.5rem;
          font-weight: 500;
          cursor: pointer;
        }

        .submitButton:hover {
          background-color: #dc2626;
        }

        .socialLogin {
          position: relative;
        }

        .socialLoginDivider {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
        }

        .socialLoginDivider::before {
          content: "";
          width: 100%;
          border-top: 1px solid #e5e7eb;
        }

        .socialLoginText {
          position: relative;
          display: flex;
          justify-content: center;
          fontSize: 0.875rem;
        }

        .socialLoginText > span {
          padding: 0 0.5rem;
          backgroundColor: white;
          color: #6b7280;
        }

        .socialButtons {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 1rem;
        }

        .socialButton {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.75rem;
          border: 1px solid #d1d5db;
          borderRadius: 0.5rem;
          backgroundColor: white;
          cursor: pointer;
        }

        .socialButton:hover {
          background-color: #f9f9f9;
        }

        .socialIcon {
          margin-right: 0.5rem;
          fontSize: 1.125rem;
        }

        .signupText {
          text-align: center;
          fontSize: 0.875rem;
          color: #6b7280;
        }

        .signupLink {
          color: #ef4444;
          cursor: pointer;
          font-weight: 500;
        }

        .signupLink:hover {
          color: #dc2626;
        }

        .errorMessage {
          color: #ff0000;
          margin-bottom: 1rem;
          text-align: center;
        }
      `}</style>
    </>
  );
};

export default OwnerLoginForm;